import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Button } from '@lusha-ui/button';
import { TextField } from '@lusha-ui/input';
import { Radio } from '@lusha-ui/radio';
import React, { useEffect, useState } from 'react';
function ScriptCustomOption(props) {
    const { checked, onChange, url } = props;
    const [value, setValue] = useState('');
    useEffect(() => {
        if (checked && url) {
            setValue(url);
        }
    }, [url, checked]);
    function handleRadioChange(checked) {
        if (checked) {
            onChange(value);
        }
    }
    return (_jsxs("div", { children: [_jsx(Radio, { value: 'custom', checked: checked, label: 'Custom', onChange: handleRadioChange }), _jsxs("div", { css: css `
          margin-left: 18px;
        `, children: [_jsx(TextField, { name: 'import', size: 'tiny', value: value, onChangeText: setValue, placeholder: 'Input url here' }), _jsx(Button, { size: 'tiny', onClick: () => onChange(value), css: css `
            margin-top: 5px;
          `, children: "Apply script" })] })] }));
}
export default ScriptCustomOption;
